import React, { useContext, useEffect, useState } from 'react'
import AgroDashboardContext from './utils/hooks/AgroDashboardContext'
import { useAuth } from '../../applications/hooks/UseAuth'
import { NurseryDashboard } from './components/NurseryDashboard'
import { PLantingDashBord } from './components/PlantingDashboard'
import PlotDashboard from './components/PLotDashboard'
import { PeasantDashBord } from './components/PeasantDashBoard'
import ComDashboardContext, { Context } from './utils/hooks/CommDashboardContext'
import CommDashboard from './components/CommDashboard'
import PlotsOverviewDashboard from './components/NewPlotDashboard'
import { CustomerDashBord } from './components/CustomerDashboard'
import { MangroDashboard } from './components/MangroDashboard'
import PeasantsOverviewDashboard from './components/PeasantsDashboard'
import MadagascarDashboard from './components/CarteDashboard'

const TABS = [
    { key: 'reg_ag_rpf', label: 'Reg Ag et RPF' },
    { key: 'mangroves', label: 'Mangroves' },
    { key: 'carte', label: 'Carte' }
]

export default function Dashboard() {
    const [needLoad, setNeedLoad] = useState(false)
    const [activeTab, setActiveTab] = useState('reg_ag_rpf')
    const user = useAuth()

    useEffect(() => {
        if (user) {
            console.log('user : >>>>>>>>>> ', user)
        }
    }, [])

    // Sur l'onglet Carte, on veut un layout en colonne contraint à la hauteur
    // de l'écran (barre d'onglets + contenu = 100vh, sans dépasser).
    // Sur les autres onglets, on garde le comportement scrollable normal.
    const isCarteTab = activeTab === 'carte'

    return (
        <div className="flex flex-col" style={isCarteTab ? { height: '100vh', overflow: 'hidden' } : undefined}>
            <div className="flex items-center gap-1 mb-6 border-b-2 border-gray-100 flex-shrink-0">
                {TABS.map((tab) => (
                    <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        className={`relative px-6 py-3 text-base font-semibold transition-colors ${
                            activeTab === tab.key
                                ? 'text-emerald-700 bg-emerald-50 rounded-t-lg'
                                : 'text-gray-400 hover:text-emerald-600'
                        }`}
                    >
                        {tab.label}
                        {activeTab === tab.key && (
                            <span className="absolute left-0 right-0 -bottom-[2px] h-[3px] bg-emerald-600 rounded-full" />
                        )}
                    </button>
                ))}
            </div>

            {activeTab === 'reg_ag_rpf' && (
                <>
                    {user.role !== 'Commercial' || user.role === 'Administrator' ? (
                        <AgroDashboardContext needLoad={needLoad} setNeedLoad={setNeedLoad}>
                            <div className="flex flex-col gap-4">
                                <NurseryDashboard setNeedLoad={setNeedLoad} needLoad={needLoad} />
                                <div className="flex gap-4">
                                    <div className="w-[70%]">
                                        <PLantingDashBord setNeedLoad={setNeedLoad} needLoad={needLoad} />
                                    </div>
                                    <div className="w-[30%] mr-[10px]">
                                        <PlotsOverviewDashboard setNeedLoad={setNeedLoad} needLoad={needLoad} />
                                    </div>
                                </div>
                                <div className="w-full">
                                    <CustomerDashBord setNeedLoad={setNeedLoad} needLoad={needLoad} />
                                </div>
                                <div className="w-full">
                                    <PeasantsOverviewDashboard setNeedLoad={setNeedLoad} needLoad={needLoad} />
                                </div>
                            </div>
                        </AgroDashboardContext>
                    ) : null}
                    {/* {user.role === 'Commercial' || user.role === 'Administrator' ? (
                        <ComDashboardContext needLoad={needLoad} setNeedLoad={setNeedLoad}>
                            <CommDashboard />
                        </ComDashboardContext>
                    ) : null} */}
                </>
            )}

            {activeTab === 'mangroves' && (
                <div className="flex flex-col gap-4">
                    <MangroDashboard setNeedLoad={setNeedLoad} needLoad={needLoad} />
                </div>
            )}

            {activeTab === 'carte' && (
                <div className="flex-1 min-h-0">
                    <MadagascarDashboard />
                </div>
            )}
        </div>
    )
}
